import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 75%;\n  padding: 18px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import ThemedButton from "../../common/ThemedButton";
import { BelowMobile } from "../../common/media-queries";
var ButtonPosition = styled(function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsx(PositionedButton, _object_spread_props(_object_spread({
            "data-testid": "next-button"
        }, rest), {
            children: /*#__PURE__*/ _jsx("span", {
                children: children
            })
        }))
    });
})(_templateObject());
var PositionedButton = styled(ThemedButton)(_templateObject1(), BelowMobile);
export default ButtonPosition;
